(function () {
  if (window.__GRP_KIT_THUMBS_BOUND__) return;
  window.__GRP_KIT_THUMBS_BOUND__ = true;

  const cache = new Map();

  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  async function fetchProduct(handle) {
    if (!handle) return null;
    if (cache.has(handle)) return cache.get(handle);

    const p = fetch(`/products/${handle}.js`, { credentials: "same-origin" })
      .then(async (res) => {
        if (!res.ok) return null;
        return res.json();
      })
      .catch(() => null);

    cache.set(handle, p);
    return p;
  }

  function ensureImg(thumbEl) {
    if (!thumbEl) return null;
    let img = thumbEl.querySelector("img");
    if (img) return img;

    // If placeholder exists, replace it with an img
    const ph = thumbEl.querySelector(".kit-thumb__ph");
    if (ph) ph.remove();

    img = document.createElement("img");
    img.width = 32;
    img.height = 32;
    img.loading = "lazy";
    thumbEl.appendChild(img);
    return img;
  }

  async function hydrateThumb(thumbEl) {
    const handle = (thumbEl.getAttribute("data-handle") || "").trim();
    if (!handle) return;

    // Find the row/title/link related to this thumb
    const rowLink = closest(thumbEl, ".kit-row-link") || thumbEl.parentElement;
    const row = closest(thumbEl, ".kit-row") || (rowLink ? closest(rowLink, ".kit-row") : null);
    const titleEl = row ? row.querySelector(".kit-row-title") : null;

    const product = await fetchProduct(handle);
    if (!product) {
      // IMPORTANT: do nothing on failure (prevents "copying" previous product)
      return;
    }

    // Update title if we have it
    if (titleEl && product.title) {
      titleEl.textContent = product.title;
    }

    // Update link if needed
    if (rowLink && rowLink.tagName === "A" && product.handle) {
      rowLink.href = `/products/${product.handle}`;
    }

    // Update image
    const imgSrc =
      (product.featured_image && (product.featured_image.src || product.featured_image)) || "";

    if (imgSrc) {
      const img = ensureImg(thumbEl);
      if (img) {
        img.src = imgSrc;
        img.alt = (product.title || handle).toString();
      }
    }
  }

  function init() {
    document.querySelectorAll("[data-kit-thumb][data-handle]").forEach((el) => {
      // Only hydrate once per element
      if (el.dataset.grpThumbHydrated === "1") return;
      el.dataset.grpThumbHydrated = "1";
      hydrateThumb(el);
    });
  }

  // Each thumb starts as a blank placeholder (.kit-thumb__ph) server-side -
  // hydrating fires one fetch per bill-of-materials line (commonly 4-6 on a
  // roofing kit), all in parallel, purely to replace those placeholders with
  // real images. None of this blocks anything visible or interactive, so it
  // runs after the browser is idle instead of immediately at script load.
  if ("requestIdleCallback" in window) {
    requestIdleCallback(init, { timeout: 2000 });
  } else {
    setTimeout(init, 200);
  }
  document.addEventListener("shopify:section:load", init);
})();